import { getColors } from "../../../jss_setup/colors";

export const GeneralCards = {
  callToActionButton: {
    background: getColors().secondary_color,
    border: `2px solid ${getColors().secondary_color}`,
    borderRadius: "0px",
    "&:hover": {
      background: "white",
      color: getColors().secondary_color,
    },
  },
  GenericCard: {
    borderRadius: "0px",
    callToActionButton: {
      background: getColors().base_color,
      border: `2px solid ${getColors().base_color}`,
      borderRadius: "0px",
    },
    callToActionButtonType2: {
      background: getColors().secondary_color,
      border: `2px solid ${getColors().secondary_color}`,
      borderRadius: "0px",
    },
    actions: { width: "100%" },
    image: {
      borderRadius: "0px",
    },
    content: {
      borderRadius: "0px",
    },
  },
};
